
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/beautyawards2025",
      function () {
        return require("private-next-pages/beautyawards2025/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/beautyawards2025"])
      });
    }
  